import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import {
  addSetting,
  removeSettingByIndex,
  setSettingByIndex,
} from "@/features/commissionSlice";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

const MemoAdjustmentFormRow = React.memo(
  function AdjustmentFormRow({
    index,
    item,
    validations,
    productOptions,
    disabled,
    removeFormData,
    promoterOptions,
    handleFormData,
  }) {
    return (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={1}
        >
          <Autocomplete
            sx={{ flex: 1 }}
            required
            id="combo-box-demo"
            options={promoterOptions}
            value={item.adjustUser}
            onChange={async (e, newValue) => {
              handleFormData(index, "adjustUser", newValue);
            }}
            label="員工"
            renderInput={(params) => <TextField {...params} label="員工" />}
          />
          <ProductAutoComplete
            multiple
            disabled={disabled}
            sx={{ flex: 1, width: 200 }}
            productOptions={productOptions}
            handleOnChange={(value) => {
              handleFormData(index, "productIds", value);
            }}
            selectedValue={item.productIds ?? []}
            error={!!validations[index]?.productIdsErr}
          ></ProductAutoComplete>
          <TextField
            disabled={disabled}
            error={!!validations[index]?.adjustAmountErr}
            helperText={validations[index]?.adjustAmountErr}
            sx={{ flex: 0.7 }}
            value={item.adjustAmount}
            type="number"
            id="outlined-basic"
            label="調整金額"
            variant="outlined"
            onChange={(event) =>
              handleFormData(index, "adjustAmount", event.target.value)
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          <TextField
            value={item.remark}
            sx={{ flex: 1 }}
            id="outlined-basic"
            error={!!validations[index]?.remarkErr}
            helperText={validations[index]?.remarkErr}
            label="備註"
            onChange={(event) =>
              handleFormData(index, "remark", event.target.value)
            }
            variant="outlined"
          />
        </Stack>
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton color="error" onClick={() => removeFormData(index)}>
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    );
  },
  (prev, next) => {
    return (
      next.index === prev.index &&
      _.isEqual(prev.item, next.item) &&
      _.isEqual(prev.validations, next.validations)
    );
  },
);

export default function AdjustmentFormRows({
  disabled,
  promoterOptions,
  productOptions,
}) {
  const dispatch = useDispatch();

  const currentDate = useSelector(
    (state) => state.commission.settings.currentDate,
  );

  const formData = useSelector(
    (state) => state.commission.settings.adjustment,
    shallowEqual,
  );

  const validations = useSelector(
    (state) => state.commission.validations.adjustment,
    shallowEqual,
  );

  const removeFormData = React.useCallback(
    async (index) => {
      dispatch(
        removeSettingByIndex({
          key: "adjustment",
          index: index,
        }),
      );
    },
    [dispatch],
  );

  const handleFormData = React.useCallback(
    async (position, key, value) => {
      let cloneRow = { ...formData[position] };
      cloneRow[key] = value;
      dispatch(
        setSettingByIndex({
          key: "adjustment",
          value: cloneRow,
          index: position,
        }),
      );
    },
    [dispatch, formData],
  );
  const createFormData = React.useCallback(() => {
    dispatch(
      addSetting({
        key: "adjustment",
        value: {
          adjustAmount: null,
          date: moment(currentDate).format("YYYY-MM-DD"),
          remark: null,
          qty: 1,
          key: formData.length + 1,
        },
      }),
    );
  }, [dispatch, currentDate, formData]);
  return (
    <React.Fragment>
      {_.map(formData, (item, index) => (
        <MemoAdjustmentFormRow
          index={index}
          item={item}
          key={item.id}
          productOptions={productOptions}
          validations={validations}
          disabled={disabled}
          removeFormData={removeFormData}
          promoterOptions={promoterOptions}
          handleFormData={handleFormData}
        ></MemoAdjustmentFormRow>
      ))}
      {!disabled && (
        <Box>
          <IconButton component="label" onClick={createFormData}>
            <AddBoxOutlinedIcon />
          </IconButton>
        </Box>
      )}
    </React.Fragment>
  );
}
